import { createAction } from '@reduxjs/toolkit';

import { SetHomeActiveTabPayload } from './types';

export const setHomeActiveTab = createAction<SetHomeActiveTabPayload>('home/tabs/set-active');
